import { Field } from '@/components/ui/field';
import { Box, Input, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface WebsiteDestinationProps {
  onUrlChange: (url: string) => void;
  url: string;
  urlIsInvalid: boolean;
}

export function WebsiteDestination({ onUrlChange, url, urlIsInvalid }: WebsiteDestinationProps) {
  const { t } = useTranslation();

  return (
    <Box>
      <Text fontSize="xs" fontWeight="semibold" color="gray.700" mb={2}>
        {t('mentions.boost.setup.destination.websiteUrlLabel')}
      </Text>
      <Field
        invalid={urlIsInvalid}
        errorText={t('mentions.boost.setup.destination.websiteUrlError')}
      >
        <Input
          h={11}
          variant="outline"
          type="url"
          value={url}
          placeholder={t('mentions.boost.setup.destination.websiteUrlPlaceholder')}
          onChange={(event) => onUrlChange(event.target.value)}
        />
      </Field>
    </Box>
  );
}
